import { render, staticRenderFns } from "./UsersSettings.vue?vue&type=template&id=8515d6b2&"
import script from "./UsersSettings.vue?vue&type=script&lang=ts&"
export * from "./UsersSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports